import { createSelector } from 'reselect';
import { get, map } from 'lodash';
import { getLandingViewPixel } from '@sparefoot/react-core/utils/tracking';

function mapCityArray(cities) {
	return map(cities, ({ city, uri }) => ({
		label: city,
		uri: `/${uri}`,
	}));
}

export default createSelector(
	({ pages }) => get(pages, 'stateContent', {}),
	(state) => state.app.baseUrl,
	(stateContent, baseUrl) => ({
		allCities: mapCityArray(stateContent.allCities),
		title: stateContent.title,
		body: stateContent.body,
		contentId: stateContent.contentId,
		location: stateContent.location,
		statusCode: stateContent.statusCode,
		stateUrl: stateContent.stateUrl,
		meta: {
			...stateContent.meta,
			canonical: `${baseUrl}/${stateContent.stateUrl}`,
		},
		trackingPixel: getLandingViewPixel({ content: stateContent }),
	}),
);
